export enum FORM_TYPES {
  CREATE,
  VIEW,
  EDIT,
}
